module.exports = __webpack_public_path__ + "img/opera.ba67c0db.gif";